/**
 * Created by andrey on 18.09.19.
 */

const Bots = function () {
    cleverapps.EventEmitter.call(this);
    this.bots = [];
    this.fakeBots = [];

    if (typeof Rumble !== "undefined" || typeof ScoreBar !== "undefined" || cleverapps.missionManager.hasCompetitions()) {
        this.load();

        this.reload();
        cleverapps.timeouts.setInterval(this.reload.bind(this), cleverapps.parseInterval(Bots.RELOAD_INTERVAL));
    }
};

Bots.prototype = Object.create(cleverapps.EventEmitter.prototype);
Bots.prototype.constructor = Bots;

Bots.prototype.reload = function () {
    if (this.reloading || cleverapps.config.norest) {
        return;
    }

    this.reloading = true;

    const onSuccess = function (players) {
        this.reloading = false;

        this.bots = [];
        for (let i = 0; i < players.length; i++) {
            if (players[i].id !== connector.platform.getUserID() && players[i].name && players[i].name.length > 0) {
                const bot = {
                    id: players[i].id,
                    name: players[i].name,
                    avatar: players[i].avatar
                };

                if (this.fakeBots.length > 0) {
                    bot.id = this.fakeBots.pop().id;
                    this.trigger("updateBotInfo", bot);
                } else {
                    this.bots.push(bot);
                }
            }
        }
        this.trigger("updateBots");
        this.save();
    }.bind(this);

    const onFailure = function () {
        this.reloading = false;
    }.bind(this);

    const amount = connector.platform.oneOf(connector.MICROSOFT) ? 30 : 50;

    cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.BOTS_LOAD);

    connector.multi.bots.get(amount, (players) => {
        if (players) {
            onSuccess(players);

            cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.BOTS_LOAD_SUCCESS);
        } else {
            onFailure();
        }
    });
};

Bots.prototype.getAmount = function () {
    return this.bots.length;
};

Bots.prototype.listBots = function (amount) {
    this.bots = this.bots.filter((player) => player.id !== connector.platform.getUserID());
    const players = this.bots.splice(0, amount);
    let i = 0;
    const names = [
        "Sophia",
        "James",
        "Emily",
        "Michael",
        "Olivia",
        "David",
        "Charlotte",
        "Andrew",
        "Isabella",
        "Robert",
        "Grace",
        "William",
        "Hannah",
        "Daniel",
        "Victoria",
        "John",
        "Amelia",
        "Thomas",
        "Elizabeth",
        "Matthew"
    ];
    while (players.length < amount) {
        const player = {
            id: Math.round(Math.random() * 1000000),
            name: names[i % names.length],
            fake: true
        };
        players.push(player);
        this.fakeBots.push(player);
        i++;
    }
    this.save();

    this.reload();

    return players;
};

Bots.prototype.load = function () {
    this.bots = cleverapps.dataLoader.load(DataLoader.TYPES.COMPETITION_PLAYERS) || [];
};

Bots.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.COMPETITION_PLAYERS, this.bots);
};

Bots.RELOAD_INTERVAL = "30 minutes";